import { getResidentData } from '@/apis/apis';
import useDocumentTitle from '@/components/Helmet'
import { useCustomLoader } from '@/components/Loader';
import CustomDialog from '@/components/material/CustomDialog';
import CustomTable from '@/components/material/CustomTable';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import axiosInstance from '@/lib/axiosInstance';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Eye, Pencil, Plus, Trash2 } from 'lucide-react';
import React, { useEffect } from 'react'
import { useLocation } from 'wouter';

const ResidentList = () => {
    useDocumentTitle('Resident List')
    const [_, navigate] = useLocation();
    const { toast } = useToast();
    const loader = useCustomLoader();
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = React.useState(0);
    const [residents, setResidents] = React.useState<any>({
        counts: 0,
        data: []
    });
    const [search, setSearch] = React.useState("");
    const [deleteModal, setDeleteModal] = React.useState<any>(null);

    const fetchResidents = async () => {
        await getResidentData({ filters: { search}, page: 0, rowsPerPage: 10 }).then(data => {
            setResidents(data);
        }).catch(err => {
            toast({
                variant: "destructive",
                title: "Error!",
                description: err?.response?.data?.message || "Something went wrong",
            })
        }).finally(() => {
            loader(false);
        })
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            loader(true);
            fetchResidents();
        }, search ? 600 : 0);
        return () => clearTimeout(timer);
    }, [search, page, rowsPerPage])

    const handleDelete = async () => {
        try {
            await axiosInstance.put(`/api/residents/${deleteModal._id}`, {
                active: deleteModal?.active == "Active" ? false : true
            });
            toast({
                variant: "success",
                title: "Success",
                description: "Resident deleted successfully",
            });
            fetchResidents();
        } catch (error : any) {
            toast({
                variant: "destructive",
                title: "Error!",
                description: error?.response?.data?.message || "Something went wrong",
            })
        } finally {
            setDeleteModal(null);
        }
    }
    return (
        <div>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant='h6' mb={2}>Resident List</Typography>
                <Button variant='default' onClick={() => navigate('/resident/add')}><Plus/> Add</Button>
            </Box>
            <Grid container spacing={2} mb={2}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField
                        label="Search"
                        variant="outlined"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        fullWidth
                        size="small"
                        placeholder='Search by First Name, Last Name, Email or Phone'
                    />
                </Grid>
            </Grid>

            <CustomTable
                headers={[
                    { id: 'residentCode', label: 'Resident Code' },
                    { id: 'firstName', label: 'First Name' },
                    { id: 'lastName', label: 'Last Name' },
                    { id: 'email', label: 'Email' },
                    { id: 'phone', label: 'Phone' },
                    { id: 'propertyId.name', label: 'Property Name' },
                    { id: 'unitId', label: 'Unit' },
                    { id: 'active', label: 'Status' },
                ]}
                data={residents?.data}
                page={page}
                setPage={setPage}
                limit={rowsPerPage}
                setLimit={setRowsPerPage}
                count={residents.counts}
                updateStatus={setDeleteModal}
                actions={[
                    // { label: 'View', icon: <Eye size={16} />, onClick: (row: any) => { navigate(`/resident/view/${row._id}`) } },
                    { label: 'Edit', icon: <Pencil size={16} />, onClick: (row: any) => { navigate(`/resident/edit/${row._id}`) } },
                ]}
            />
            {deleteModal &&
                <CustomDialog
                    title={`${deleteModal?.active == "Active" ? "Deactivate" : "Activate"} Resident Person`}
                    content={`Are you sure you want to ${deleteModal?.active == "Active" ? "Deactivate" : "Activate"} <span style="font-weight: 600; color: red">${deleteModal.firstName} ${deleteModal.lastName}</span> resident?`}
                    onClose={() => setDeleteModal(null)}
                    onConfirm={handleDelete}
                    confirmText='Yes, Continue'
                />  
                    
            }
        </div>
    )
}

export default ResidentList